import { IDetailStep } from 'models';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  getUserSubscriptionWithProducts,
  SubscriptionWithProducts,
} from 'shared/services/user-subscription';

interface UseSubscriptionsReturn {
  steps: IDetailStep[];
  navigate: ReturnType<typeof useNavigate>;
  sub: SubscriptionWithProducts;
  loading: boolean;
  error: boolean;
  refreshSubscription: () => void;
}

const STEPS: IDetailStep[] = [
  {
    description: 'ajustes',
    state: 'active',
    link: '/settings',
    permissionToNavigate: true,
  },
  {
    description: 'suscripciones',
    state: 'active',
    link: '/settings/subscriptions',
    permissionToNavigate: true,
  },
  {
    description: 'detalle',
    state: 'active',
    link: '',
    permissionToNavigate: false,
  },
];

export const useSubscriptionDetails = (): UseSubscriptionsReturn => {
  const { subId } = useParams();
  const navigate = useNavigate();
  const [subscriptionWithProducts, setSubscriptionWithProducts] =
    useState<SubscriptionWithProducts>({} as SubscriptionWithProducts);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const getProductsBySubId = async () => {
    setLoading(true);
    setError(false);
    try {
      if (!subId) throw new Error('Subscription ID is missing');
      const sub = await getUserSubscriptionWithProducts(subId);
      setSubscriptionWithProducts(sub);
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const refreshSubscription = () => {
    getProductsBySubId();
  };

  useEffect(() => {
    getProductsBySubId();
  }, [subId]);

  return {
    steps: STEPS,
    navigate,
    sub: subscriptionWithProducts,
    loading,
    error,
    refreshSubscription,
  };
};
